// extracted by mini-css-extract-plugin
export default {"root":"UploadImage_root__rz8t5","actionsWrapper":"UploadImage_actionsWrapper__4nzkV","disabled":"UploadImage_disabled__6Qvdg"};